import { useTranslation } from "react-i18next";
import PageTemplate from "../../components/PageTemplate/PageTemplate";
import YoungTalents from "../../modals/components/JobAds/YoungTalents";

export default function YoungTalentsPage() {
  const { t } = useTranslation();
  return (
    <PageTemplate title={t("young_talents.title")} content={<YoungTalents />} />
  );
}
